import React, { useContext } from 'react';

import styled from '@emotion/styled';

import ChevronLeftIcon from '../../../Icons/ChevronLeftIcon';
import TranslatingContainer from '../../../TranslatingContainer/TranslatingContainer';
import TranslatingContainerProvider, {
  TranslatingContainerContext,
} from '../../../TranslatingContainer/TranslatingContainerProvider';
import ModalContainer from '../../ModalContainer';
import SelectKindOfPayment from './SelectKindOfPayment';
import TriggerPaymentForPaymentKind from './TriggerPaymentForPaymentKind';

interface LookupModalContentProps {
  modalTitle: string;
  setModalTitle: (title: string) => void;
}

const LookupModalContent: React.FC<LookupModalContentProps> = ({
  modalTitle,
  setModalTitle,
}) => {
  const { sliderIndex, resetSliderIndex } = useContext(
    TranslatingContainerContext,
  )!;

  return (
    <ModalContainer
      label={
        modalTitle === 'Get More Look-ups' ? (
          modalTitle
        ) : (
          <ModalHeader
            onClick={() => {
              resetSliderIndex();
              setModalTitle('Get More Look-ups');
            }}
          >
            <ChevronLeftIcon />
            <div>{modalTitle}</div>
          </ModalHeader>
        )
      }
      description={
        sliderIndex === 0
          ? `Choose how you'd like to purhcase additional look-ups.`
          : ''
      }
    >
      <Container>
        <TranslatingContainer>
          <SelectKindOfPayment setModalTitle={setModalTitle} />
          <TriggerPaymentForPaymentKind modalTitle={modalTitle} />
        </TranslatingContainer>
      </Container>
    </ModalContainer>
  );
};

const LookupModal = () => {
  const [modalTitle, setModalTitle] = React.useState('Get More Look-ups');

  return (
    <TranslatingContainerProvider>
      <LookupModalContent
        modalTitle={modalTitle}
        setModalTitle={setModalTitle}
      />
    </TranslatingContainerProvider>
  );
};

export default LookupModal;

const Container = styled.div`
  display: flex;
  overflow: hidden;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;

  & > div {
    font-weight: 600;
    font-size: 16px;
    line-height: 16px;
    color: ${({ theme }) => theme.palette.primaryTextColor};
  }
`;
